import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";

export default function MyProposals() {
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/proposals/mine");
        setProposals(data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-5xl mx-auto px-6 md:px-10 py-10 md:py-16">
        <div className="mb-10">
          <div className="text-xs tracking-widest uppercase text-primary font-bold mb-2">Propuestas</div>
          <h1 className="font-heading text-3xl md:text-5xl font-bold tracking-tight">Mis propuestas</h1>
        </div>

        {loading ? (
          <div className="text-muted-foreground text-center py-20">Cargando…</div>
        ) : proposals.length === 0 ? (
          <div className="border border-dashed border-border rounded-lg p-12 text-center text-muted-foreground">
            Aún no has enviado propuestas. <Link to="/projects" className="text-primary hover:underline">Explora proyectos</Link>.
          </div>
        ) : (
          <div className="space-y-3">
            {proposals.map((p) => (
              <Link key={p.proposal_id} to={`/projects/${p.project_id}`} data-testid={`my-proposal-${p.proposal_id}`}>
                <Card className="lift">
                  <CardContent className="p-6 flex items-center justify-between gap-4 flex-wrap">
                    <div className="flex-1 min-w-[240px]">
                      <div className="text-xs tracking-widest uppercase text-muted-foreground font-bold mb-1">{p.project?.category}</div>
                      <h3 className="font-heading text-lg font-semibold">{p.project?.title || "Proyecto"}</h3>
                      <p className="text-sm text-muted-foreground mt-1 line-clamp-1">{p.message}</p>
                    </div>
                    <div className="text-right">
                      <div className="text-2xl font-heading font-bold">${p.amount.toFixed(0)}</div>
                      <div className={`text-[10px] tracking-widest uppercase font-bold mt-1 ${
                        p.status === 'accepted' ? 'text-emerald-600' : p.status === 'rejected' ? 'text-destructive' : 'text-muted-foreground'
                      }`}>
                        {p.status === 'accepted' ? 'Aceptada' : p.status === 'rejected' ? 'Rechazada' : 'Pendiente'}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
